import { createContext, useEffect, useRef } from "react";
import { generateGUID } from "./helper";
import axios, { AxiosError } from "axios";

import qs from "qs";

import { BASE_URL } from "../config";
import { requestKey } from "./helper";

export const RequestFormContext = createContext();


export const RequestFormProvider = ({ children }) => {
  const requestForm = useRef({ Firmendaten: {}, Standorte: [] });

  const setFirmendaten = (data) => {
    requestForm.current.Firmendaten = data;

    //console.log(requestForm.current);
  };

  const setStandortdaten = (data, delstandort = false) => {
    if (delstandort) {
      let branches = requestForm.current.Standorte.filter((item) => item.intid != data.intid);
      requestForm.current.Standorte = branches;
    }
    else {
      let branch = requestForm.current.Standorte.find((item) => item.intid == data.intid);

      if (branch) {
        let idx = requestForm.current.Standorte.indexOf(branch);
        requestForm.current.Standorte[idx] = data;
      } else requestForm.current.Standorte.push(data);
    }
    //console.log(requestForm.current.Standorte);
  };

  const sendRequest = async (emailconfirm) => {
    return new Promise(async (resolve, reject) => {
      const url = `${BASE_URL}/requestdata`;
      const requestdata = JSON.stringify(requestForm.current,null," ");

      let data = {
        action: "sendrequestdata",
        requestdata: btoa(requestdata),
        emailconfirm: emailconfirm?"1":"0"

      };
      let options = {
        method: "POST",
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          "Requestkey" : requestKey
        },
        data: qs.stringify(data),
        url,
      };
      await axios(options)
        .then((res) => {
          //console.log(res);
          let _data = res.data;
          if (_data && _data.result == "OK") {
            resolve({ result: "OK", reason: "" });
          } else if (_data && _data.result == "Failed") {
            console.log(`Send Request error: ${_data.reason}`);
            reject({ result: "Failed", code: 200, reason: "" });
          }
          else {
            console.log(res.data);
            reject({ result: "Failed", code: 200, reason: "" });
          }
        })
        .catch((e) => {
          //console.log(e);
          console.log(`Send Request error ${e}`);
          reject({
            result: "Failed",
            code: e.response ? e.response.status : 500,
            reason: e.response ? e.response.data : `${e}`,
          });
        });
    });
  };



  /*useEffect(() => {
    const branchid = generateGUID(32);

    requestForm.current = { 
      Firmendaten: {
        firma : "Testfirma",
        ansprechpartner : "Martin Mustermann",
        telefon : "01234 / 56789",
        email : "info@mustermann.de",
        strasse : "Teststrasse 1",
        ort : "01234 Testort"
      }, 
      Standorte: [
        {
          isnew: true,
          intid: branchid,
          standort: "Teststandort",
          telefon: "01234 / 56789",
          strasse: "Teststrasse 1",
          ort: "01234 Testort",
          email: "",
  
          messstellen : [
            {
              isnew: true,
              intid: generateGUID(32),
              branchid: branchid,
              bezeichnung: "Messstelle1",
              min: "1",
              max: "2"
            },
          ],
  
          benutzer : [
            {
              isnew: true,
              intid: generateGUID(32),
              branchid: branchid,
              name: "Martin Mustermann",
            },
          ]
  
        }
      ] 
    };
  }, []);*/

  return (
    <RequestFormContext.Provider
      value={{
        setFirmendaten,
        setStandortdaten,
        sendRequest,
        requestForm,
      }}
    >
      {children}
    </RequestFormContext.Provider>
  );
};
